import styled, { css } from "styled-components";

export const Mask = styled.div`
	position: fixed;
	top:0px;
	left:0px;
	height:100%;
	width: 100%;
	background: rgba(0,0,0,0.7);
	z-index: 50;
`

export const Container = styled.div`
 	position: absolute;
  height: 90px;
  width: 90px;
  bottom: 50%;
	left: 50%;
	transform:translate(-50%,50%);
`;
